import React, { createContext, useState, useMemo } from 'react';
import PropTypes from 'prop-types';

export const CurrencyContext = createContext({
    currentCurrency: 'eur',
    setCurrency: () => {}
});

export function CurrencyProvider({ children }) {
    const [currentCurrency, setCurrency] = useState('eur');

    const value = useMemo(
        () => ({
            currentCurrency,
            setCurrency
        }),
        [currentCurrency]
    );

    return <CurrencyContext.Provider value={value}>{children}</CurrencyContext.Provider>;
}

CurrencyProvider.propTypes = {
    children: PropTypes.node.isRequired
};
